<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="pageTitle" routeBack="InvestorContratIndex"/>
        <div>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>

      <div v-if="contrats.avp && contrats.exe">
        <b-nav class="multi-tabs-field-navbar">
          <b-nav-item
            :class="{ 'link-active': currentTab === 'avp' }"
            class="multi-tabs-field-navbar-item"
            @click.prevent="currentTab = 'avp'"
          >
            AVP
          </b-nav-item>
          <b-nav-item
            :class="{ 'link-active': currentTab === 'exe' }"
            class="multi-tabs-field-navbar-item"
            @click.prevent="currentTab = 'exe'"
          >
            EXE
          </b-nav-item>
        </b-nav>
      </div>

      <div v-if="currentContrat">
        <InvestorContratDetails
          :contrat="currentContrat"
          @refresh="fetchData"
          @delete-refund="openRefundDelete"
          @delete-interest="openInterestDelete"
        />
      </div>
    </b-container>

    <Item-delete-modal
      id="contrat-delete-modal"
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="currentContrat"
      :selectedItemSpecialString="`'${currentContrat ? currentContrat.toStringWithBilan : null}'`"
      controllerName="investorContrat"
      itemSingularName="contrat"
      itemSingularNameUpp="Contrat"
      @didDeleteItem="didDeleteContrat()"
    />

    <Item-delete-modal
      id="refund-delete-modal"
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selected-item-special-string="selectedRefund ? ' de ' + convertToEuros(selectedRefund.amount) + ' du ' + convertDateToStr(selectedRefund.dateRefund) : null"
      :selectedItem="selectedRefund"
      controllerName="investorRefund"
      itemSingularName="remboursement"
      itemSingularNameUpp="Remboursement"
      @didDeleteItem="didDeleteRefund()"
    />

    <Item-delete-modal
      id="interest-delete-modal"
      :beginsWithVoyel="true"
      :isFeminine="false"
      :selected-item-special-string="selectedInterest ? ' de ' + convertToEuros(selectedInterest.amount) + ' du ' + convertDateToStr(selectedInterest.dateInterest) : null"
      :selectedItem="selectedInterest"
      controllerName="investorInterest"
      itemSingularName="intérêt"
      itemSingularNameUpp="Intérêt"
      @didDeleteItem="didDeleteInterest()"
    />
  </div>
</template>

<script>
import BackArrow from "../../components/b122/BackArrow"
import InvestorContratDetails from "./components/InvestorContratDetails"
import ItemDeleteModal from "../../components/b122/ItemDeleteModal"
import api from "../../services/api"

export default {
  name: "InvestorShow",
  components: { BackArrow, InvestorContratDetails, ItemDeleteModal },

  data() {
    return {
      investorContratId: this.$route.params.investorContratId,
      contrats: { avp: null, exe: null },
      currentTab: "avp",
      selectedRefund: null,
      selectedInterest: null
    }
  },

  computed: {
    pageTitle() {
      if (this.contrats.avp && this.contrats.exe) {
        return this.contrats.avp.name || this.contrats.exe.name
      }
      if (this.contrats.avp && this.contrats.avp.name) {
        return this.contrats.avp.name
      }
      if (this.contrats.exe && this.contrats.exe.name) {
        return this.contrats.exe.name
      }
      return this.$t("contrat")
    },
    currentContrat() {
      if (this.contrats.avp && this.contrats.exe) {
        return this.currentTab === "avp" ? this.contrats.avp : this.contrats.exe
      }
      return this.contrats.avp || this.contrats.exe
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    convertDateToStr(dateMillis) {
      return new Date(dateMillis).toLocaleDateString()
    },
    convertToEuros(value) {
      let euros = (value / 100).toFixed(2)
      return Intl.NumberFormat().format(euros) + " €"
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'InvestorContratCreateEdit',
        params: { investorContratId: this.currentContrat.id }
      })
    },
    clickOnDeleteBtn() {
      this.$bvModal.show('contrat-delete-modal')
    },

    openRefundDelete(refund) {
      this.selectedRefund = refund
      this.$bvModal.show('refund-delete-modal')
    },
    openInterestDelete(interest) {
      this.selectedInterest = interest
      this.$bvModal.show('interest-delete-modal')
    },

    didDeleteContrat() {
      this.$router.push({ name: 'InvestorContratIndex' })
    },
    async didDeleteRefund() {
      this.selectedRefund = null
      await this.fetchData()
    },
    async didDeleteInterest() {
      this.selectedInterest = null
      await this.fetchData()
    },

    async fetchData() {
      await api.get(`/investorContrat/showGroup/${this.investorContratId}`)
        .then(response => {
          this.contrats = response.data

          if (this.contrats.avp && this.contrats.exe) {
            if (this.contrats.avp.id === Number(this.investorContratId)) {
              this.currentTab = "avp"
            } else if (this.contrats.exe.id === Number(this.investorContratId)) {
              this.currentTab = "exe"
            } else {
              this.currentTab = "avp"
            }
          } else if (this.contrats.exe && !this.contrats.avp) {
            this.currentTab = "exe"
          } else {
            this.currentTab = "avp"
          }
        })
    }

  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/investor/InvestorShow.vue